import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

const TOOLZZ_CHAT_PENDING_REDIRECT = 'toolzz_chat_pending_redirect';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

export const consumePendingConsentRedirect = () => {
  const pending = window.sessionStorage.getItem(TOOLZZ_CHAT_PENDING_REDIRECT);
  if (!pending) return null;

  window.sessionStorage.removeItem(TOOLZZ_CHAT_PENDING_REDIRECT);

  try {
    const u = new URL(pending);
    if (u.origin !== window.location.origin) return null;
    if (u.pathname !== '/pagina-chat') return null;
    return u.toString();
  } catch {
    return null;
  }
};

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id = null } = user || {};
  const ssoAccount = accounts.find(
    account => account.id === Number(ssoAccountId)
  );
  let accountPath = '';
  if (ssoAccount) {
    accountPath = `accounts/${ssoAccountId}`;
  } else if (accounts.length) {
    // If the account id is not found, redirect to the first account
    const accountId = account_id || accounts[0].id;
    accountPath = `accounts/${accountId}`;
  }
  return accountPath;
};

export const getLoginRedirectURL = ({
  ssoAccountId,
  ssoConversationId,
  user,
}) => {
  if (!user.active) {
    return frontendURL('app/login?error=account-deactivated');
  }
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
